import { tv } from '@workspace/lib';
import { stripInvisibles } from '@workspace/constants';

export interface MiddleBannerTextContrastInput {
  backgroundClass?: string;
  isImageBg?: boolean;
  textColor?: 'light' | 'dark' | string;
}

export const shouldUseLightText = ({ backgroundClass, isImageBg, textColor }: MiddleBannerTextContrastInput) => {
  if (textColor === 'light') return true;
  if (textColor === 'dark') return false;
  return Boolean(isImageBg || backgroundClass === 'bg-primary' || backgroundClass === 'bg-primary-500');
};

export const normalizeAlignment = (alignment?: string): 'left' | 'center' | 'right' => {
  const clean = stripInvisibles(alignment?.trim()).toLowerCase();
  if (clean === 'left' || clean === 'text-left') return 'left';
  if (clean === 'right' || clean === 'text-right') return 'right';
  return 'center';
};

export const middleBannerVariants = tv({
  slots: {
    section: '',
    container: 'pb-20 py-xl px-md md:py-3xl md:px-md-banner',
    content: 'space-y-4',
    heading: 'font-bold text-primary',
    subheading: 'font-bold text-neutral-900',
    body: 'mt-8 prose prose-lg max-w-none',
    buttonWrapper: 'mt-8',
    button: 'w-full md:w-auto',
  },
  variants: {
    hasLightText: {
      true: {
        heading: 'text-white',
        subheading: 'text-white',
        body: 'text-white prose-invert',
      },
      false: {},
    },
    headingAlignment: {
      left: { heading: 'text-center md:text-left' },
      center: { heading: 'text-center' },
      right: { heading: 'text-center md:text-right' },
    },
    subheadingAlignment: {
      left: { subheading: 'text-center md:text-left' },
      center: { subheading: 'text-center' },
      right: { subheading: 'text-center md:text-right' },
    },
    bodyAlignment: {
      left: { body: 'text-center md:text-left' },
      center: { body: 'text-center' },
      right: { body: 'text-center md:text-right' },
    },
  },
  defaultVariants: {
    hasLightText: false,
    headingAlignment: 'center',
    subheadingAlignment: 'center',
    bodyAlignment: 'center',
  },
});
